
import GlobalEdit from "../../../assets/duotone/GlobalEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GlobalEditIcon({ className, dataTestid = "GlobalEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GlobalEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
